export enum AnalyticEventType {
    VirtualScreenView = "virtual_screen_view",
    Lead = "Lead",
    AddToCart = "AddToCart",
}
